import isFuture from 'date-fns/isFuture';
import {Showing} from "features/search/types";
import {ShowingsType} from 'features/search/enums';
import {isEmpty} from 'features/services/utils/helpers';
import {StageStatus} from 'features/search/filters/enums';


export const showingIsFuture = (showing: Showing) => {
    const today = new Date();
    if(typeof showing === 'undefined' || showing === null || isEmpty(showing)) return false;
    if (new Date(showing.endDate) < today) return false;
    
    return true;
};
export const showingIsVisible = (showing: Showing, userIsVip: boolean) => {
    const showingIsVip = showing.type === ShowingsType.VIP;

    if(showingIsVip && !userIsVip) {
        return false;
    }
    
    return true;
};

export const hasShowing = (showings: Showing[] | undefined, stageStatus: string, showingText: string | undefined) => {
    const today = new Date();
    let filteredShowings: Showing[] = [];

    if (showings) {
        filteredShowings = showings.filter(x => showingIsFuture(x));

        filteredShowings = filteredShowings.filter(x => new Date(x.endDate) > today).sort(function (a, b) {
            if (a.startDate > b.startDate) return 1;
            if (a.startDate < b.startDate) return -1;
            return 0;
        });
    }
    if(stageStatus === StageStatus.PLANNED) {
        filteredShowings = filteredShowings.filter(x => showingIsVisible(x, false)); // Hide VIP showings for planned projects
    }

    if(stageStatus === StageStatus.SOLD_OUT) return false;
    if(stageStatus !== StageStatus.PLANNED && (showingText && showingText !== "")) return true;

    return filteredShowings.length > 0;
};

export const getFirstValidShowing = (showings: Showing[], vipStart?: number) => {
    const filteredShowing = showings.filter(x => x && isFuture(x.endDateTimeStamp * 1000) && (x.type == ShowingsType.REGULAR || (x.type == ShowingsType.VIP && vipStart && !isFuture(new Date(vipStart)))));
    return filteredShowing && filteredShowing.length > 0 ? filteredShowing[0] : null;
};

/*
export const shouldRenderShowing = (showing: Showing | null, stageStatus: string, isUserVip?: boolean, vipStart?: number, vipEnd?: number) => {
    if(typeof showing === 'undefined' || showing === null || isEmpty(showing)) return false;

    if (showing.endDateTimeStamp && showing.endDateTimeStamp * 1000 < new Date().getTime()) return false;

    const showingIsVip = showing.type === ShowingsType.VIP;
    const stageIsVip = stageStatus === StageStatus.VIP;
    const stageIsPlaned = stageStatus === StageStatus.PLANNED;

    if(showingIsVip && isUserVip && (stageIsVip || stageIsPlaned && vipStart && !isFuture(new Date(vipStart)) && vipEnd && isFuture(new Date(vipEnd)))) {
        return true;
    }
    
    return !showingIsVip;
};

export const shouldShowShowingsMenu = (showings: Showing[], stageStatus: string, showingText: string) => {
    const today = new Date();
    let filteredShowings: Showing[] = [];

    if (showings) {
        filteredShowings = showings.filter(x => shouldRenderShowing(x, stageStatus));

        filteredShowings = filteredShowings.filter(x => new Date(x.endDate) > today).sort(function (a, b) {
            if (a.startDate > b.startDate) return 1;
            if (a.startDate < b.startDate) return -1;
            return 0;
        });
    }

    if(stageStatus === StageStatus.SOLD_OUT) return false;
    //if(stageStatus === StageStatus.PLANNED) return false;
    if(stageStatus !== StageStatus.PLANNED && (showingText && showingText !== "")) return true;

    return filteredShowings.length > 0;
};*/
